import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import t from "../core/Plugin";
import i from "./FieldStatus";

var s = /*#__PURE__*/function (_t) {
  _inherits(s, _t);

  var _super = _createSuper(s);

  function s(t) {
    var _this;

    _classCallCheck(this, s);

    _this = _super.call(this, t);
    _this.fieldStatusPluginName = "___autoFocusFieldStatus";
    _this.opts = Object.assign({}, {
      onPrefocus: function onPrefocus() {}
    }, t);
    _this.invalidFormHandler = _this.onFormInvalid.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(s, [{
    key: "install",
    value: function install() {
      this.core.on("core.form.invalid", this.invalidFormHandler).registerPlugin(this.fieldStatusPluginName, new i());
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.core.off("core.form.invalid", this.invalidFormHandler).deregisterPlugin(this.fieldStatusPluginName);
    }
  }, {
    key: "onFormInvalid",
    value: function onFormInvalid() {
      var t = this.core.getPlugin(this.fieldStatusPluginName);
      var i = t.getStatuses();

      var _s = Object.keys(this.core.getFields()).filter(function (t) {
        return i.get(t) === "Invalid";
      });

      if (_s.length > 0) {
        var _t2 = _s[0];

        var _i = this.core.getElements(_t2);

        if (_i.length > 0) {
          var _s3 = _i[0];
          var e = {
            firstElement: _s3,
            field: _t2
          };
          this.core.emit("plugins.autofocus.prefocus", e);
          this.opts.onPrefocus(e);

          _s3.focus();
        }
      }
    }
  }]);

  return s;
}(t);

export { s as default };